// tastiRadio.ts — frecce della tastiera nei gruppi di scelte fatti di pulsanti role="radio" (avatar, colori, lingue):
// come i radio veri, le frecce spostano la scelta e il fuoco; con Tab si entra solo sulla scelta attuale (v022).

const PASSI: Record<string, number> = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: -Infinity, End: Infinity };

export function tastiRadio(e: { key: string; currentTarget: HTMLElement; preventDefault: () => void }): void {
  const passo = PASSI[e.key];
  if (passo === undefined) return;
  const voci = [...e.currentTarget.querySelectorAll<HTMLElement>('[role="radio"]')];
  if (!voci.length) return;
  const ora = voci.indexOf(document.activeElement as HTMLElement);
  // da destra a sinistra le frecce orizzontali vanno al contrario
  const rtl = getComputedStyle(e.currentTarget).direction === "rtl" && (e.key === "ArrowRight" || e.key === "ArrowLeft");
  const verso = rtl ? -passo : passo;
  const i =
    verso === -Infinity ? 0 : verso === Infinity ? voci.length - 1 : (Math.max(ora, 0) + verso + voci.length) % voci.length;
  e.preventDefault();
  voci[i]!.focus();
  voci[i]!.click();
}

